import { z } from 'zod';
import { IsoDateSchema, IsoTimestampSchema, MontoClpSchema, PeriodoSchema, UlidSchema } from './common.js';

export const ResumenFinancieroSchema = z.object({
  tenantId: UlidSchema,
  periodo: PeriodoSchema,
  montoEmitido: z.number().int().min(0),
  montoCobrado: z.number().int().min(0),
  montoAnulado: z.number().int().min(0),
  cantidadGastos: z.number().int().min(0),
  cantidadCargos: z.number().int().min(0),
  cargosPagados: z.number().int().min(0),
  cargosVencidos: z.number().int().min(0),
  cargosAnulados: z.number().int().min(0),
  cargosReembolsados: z.number().int().min(0),
  fondoSaldo: z.number().int().min(0),
  version: z.number().int().min(0),
  updatedAt: IsoTimestampSchema,
});
export type ResumenFinanciero = z.infer<typeof ResumenFinancieroSchema>;

export const ProximoVencimientoSchema = z.object({
  gastoId: UlidSchema,
  periodo: PeriodoSchema,
  fechaVencimiento: IsoDateSchema,
  montoPendiente: MontoClpSchema,
});

export const DashboardFinancieroResponseSchema = z.object({
  periodo: PeriodoSchema,
  montoEmitido: z.number().int().min(0),
  montoCobrado: z.number().int().min(0),
  montoPendiente: z.number().int().min(0),
  montoAnulado: z.number().int().min(0),
  tasaCobro: z.number().min(0).max(100),
  cantidadCargos: z.number().int().min(0),
  cargosPagados: z.number().int().min(0),
  cargosPendientes: z.number().int().min(0),
  cargosVencidos: z.number().int().min(0),
  fondoSaldo: z.number().int().min(0),
  fondoDeltaMes: z.number().int(),
  proximosVencimientos: z.array(ProximoVencimientoSchema),
});
export type DashboardFinancieroResponse = z.infer<typeof DashboardFinancieroResponseSchema>;
